<template>
  <pcg-box :header="header" class="main-class">
    <div v-for="period in employmentPeriods" :key="period" class="employment-row">
      <div class="employment-text">
        <span>{{ $t('general.from') }} {{ $d(new Date(period.dateFrom), 'short') }} {{ $t('general.to') }}</span>
        <span v-if="period.dateTo">{{ $d(new Date(period.dateTo), 'short') }}</span>
        <span v-else>{{ $t('components.dn_employment_period.current') }}</span>
      </div>
      <div v-if="period.positionGroup" class="employment-text">{{ $t(`components.dn_employment_period.${period.positionGroup}`) }}</div>
      <div v-else class="employment-text">{{ $t('components.dn_employment_period.other') }}</div>
    </div>
  </pcg-box>
</template>

<script>

export default {
  name: 'DnEmploymentPeriod',
  props: {
    innerHeader: Boolean,
    employmentPeriods: Array
  },
  computed: {
    header () {
      return this.innerHeader ? null : this.$t('components.dn_employment_period.header')
    }
  }
}
</script>

<style scoped lang="scss">
@import '../assets/stylesheets/vars';

.main-class {
  /deep/ .header-title {
    font-size: $font-size-xl;
    font-weight: 600;
    letter-spacing: .1rem;
    text-transform: uppercase;
  }
}

.employment-row {
  padding-bottom: .5rem;
  margin-bottom: .5rem;
  border-bottom: 1px solid $pcg-lightest-gray-background;
}

.employment-text {
  color: $pcg-gray;
  font-weight: 400;
}

</style>

<style lang="scss" scoped>
@import "../assets/stylesheets/vars-contrast";
.contrast {
  .employment-row {
    border-bottom: 1px solid $pcg-lightest-gray;
  }
  .employment-text {
    color: $pcg-gray;
  }
}
</style>
